import { render, staticRenderFns } from "./boutique.vue?vue&type=template&id=ff1ffabc&scoped=true&"
import script from "./boutique.vue?vue&type=script&lang=js&"
export * from "./boutique.vue?vue&type=script&lang=js&"
import style0 from "./boutique.vue?vue&type=style&index=0&lang=css&"
import style1 from "./boutique.vue?vue&type=style&index=1&id=ff1ffabc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1ffabc",
  null
  
)

export default component.exports